var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TenderTable',{attrs:{"api_url":_vm.$store.state.api_url+ '/tender/get_by_user_id',"search":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }